export function formatCountWithMax(count: number, max?: number): string {
  return max !== undefined && count > max ? `${max}+` : String(count)
}
